import React, { useState, useEffect, useContext } from 'react'
import { WebSocketContext } from 'contexts/WebSocketProvider'
import mockFriend from './friends'
import Friend from './Friend'
import Chat from './Chat'
import httpClient, { getBaseURL } from 'utility/httpClient.util'
import useAuth from 'hooks/useAuth'
import objectPath from 'object-path'
const onlineGroupName = 'online-group'
const Friends = ({ listOpen }) => {
  const {
    connected,
    currentChannel,
    socket,
    enableDebugLog,
    subscribe,
    unsubscribe,
    bindBroadcast,
    unbindBroadcast,
    broadcastMessage,
    pushMessage,
  } = useContext(WebSocketContext)
  const [chatOpen, setChatOpen] = useState(listOpen)
  const [activeUser, setActiveUser] = useState([])
  const [friend, setFriend] = useState([])
  const { user } = useAuth()

  useEffect(async () => {
    setChatOpen(false)
    await loadFriendList()
  }, [listOpen])

  useEffect(() => {
    if (!connected || !user) {
      return
    }
    enableDebugLog(process.env.NODE_ENV == 'development')
    const eventName = 'socket_internal::subscription_change'
    const channel = subscribe(onlineGroupName)
    channel.bind(eventName, async (event) => {
      console.log('channelChange', event)
      await loadFriendList()
    })
  }, [connected, user])

  const loadFriendList = async () => {
    const users = await httpClient
      .get(`/socket/notification/users?channel=${onlineGroupName}`)
      .then(
        ({ data }) => (data && objectPath.get(data, ['data', 0, 'users'])) || []
      )
      .catch(() => [])
    //debugger
    setFriend(
      users.map((item) => {
        const me = user?.userId === item.userId ? ' (Me) ' : ''
        const randomNumber =
          Math.floor(Math.random() * mockFriend.length) + 1 - 1
        const socketText =
          item.socketCount > 1 ? ` (${item.socketCount} Online) ` : ''
        const photoUrl = item?.profileAttachmentId
          ? `${getBaseURL()}/media/attachment/thumbnail/${
              item.profileAttachmentId
            }`
          : null
        return {
          id: item.userId,
          photo: mockFriend[randomNumber]?.photo || 'avatar-1.jpg',
          photoUrl: photoUrl,
          name: item.name + me + socketText,
          new: 0,
          status: 0,
          time: item.lastSubscriptionAt,
        }
      })
    )
  }

  const friendList = friend.map((f) => {
    return (
      <Friend
        key={f.id}
        data={f}
        activeId={activeUser.id}
        clicked={() => {
          if (f.id === user?.userId) return
          setChatOpen(true)
          setActiveUser(f)
        }}
      />
    )
  })

  return (
    <React.Fragment>
      {friendList}
      <Chat
        user={activeUser}
        chatOpen={chatOpen}
        listOpen={listOpen}
        closed={() => {
          setChatOpen(false)
          setActiveUser([])
        }}
      />
    </React.Fragment>
  )
}

export default Friends
